export default __webpack_public_path__ + "static/media/quiz.1680b5b6.PNG";